<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Account Settings" />
    </div>
    <!-- Search and Create new package -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="checkout-tabs">
          <b-tabs
            pills
            vertical
            nav-class="p-0"
            nav-wrapper-class="col-xl-2 col-sm-3"
          >
            <b-tab active>
              <template v-slot:title>
                <i class="bx bxs-user d-block check-nav-icon mt-4 mb-2"></i>
                <p class="fw-bold mb-4">
                  {{ $t("menuitems.administration.list.account.list.profile") }}
                </p>
              </template>
              <b-card-text>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">
                      {{
                        $t(
                          "menuitems.administration.list.account.list.profileInformation"
                        )
                      }}
                    </h4>
                    <hr />
                    <b-form @submit.prevent="saveProfile">
                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="input-name">First Name</label>
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="profile.firstName"
                            placeholder="Enter your first name"
                            required
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="input-name">Last Name</label>
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="profile.lastName"
                            placeholder="Enter your last name"
                            required
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="billing-email-address"
                            >Email Address</label
                          >
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="profile.email"
                            placeholder="Enter your email"
                            required
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="billing-phone">Mobile</label>
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="profile.mobile"
                            placeholder="Enter your mobile no."
                            required
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <hr />
                      <b-row class="mb-4">
                        <b-col md="2"> </b-col>
                        <b-col md="10">
                          <b-button type="submit" variant="primary">
                            <i class="bx bxs-save mr-2"></i
                            >{{
                              $t(
                                "menuitems.administration.list.account.list.save"
                              )
                            }}</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-form>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <i class="bx bxs-key d-block check-nav-icon mt-4 mb-2"></i>
                <p class="fw-bold mb-4">
                  {{
                    $t(
                      "menuitems.administration.list.account.list.changePassword"
                    )
                  }}
                </p>
              </template>
              <b-card-text>
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">
                      {{
                        $t(
                          "menuitems.administration.list.account.list.changePassword"
                        )
                      }}
                    </h4>
                    <hr />
                    <b-form @submit.prevent="savePassword">
                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="input-name">{{
                            $t("menuitems.administration.list.account.list.old")
                          }}</label>
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="changePassword.oldPassword"
                            type="password"
                            placeholder="Enter your current password"
                            required
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="input-name">{{
                            $t("menuitems.administration.list.account.list.new")
                          }}</label>
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="changePassword.newPassword"
                            type="password"
                            placeholder="Enter your new password"
                            required
                          ></b-form-input>
                        </b-col>
                      </b-row>

                      <b-row class="mb-4">
                        <b-col md="2">
                          <label for="input-name">{{
                            $t(
                              "menuitems.administration.list.account.list.repeat"
                            )
                          }}</label>
                        </b-col>
                        <b-col md="10">
                          <b-form-input
                            v-model="changePassword.repeatPassword"
                            type="password"
                            placeholder="Enter your current password"
                            id="formCheckRight2"
                            required
                          ></b-form-input>
                          <div class="form-check form-check-right mt-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              @click="showPassword"
                            />
                            <label
                              class="form-check-label"
                              for="formCheckRight2"
                            >
                              Show Password
                            </label>
                          </div>
                        </b-col>
                      </b-row>
                      <hr />
                      <b-row class="mb-4">
                        <b-col md="2"> </b-col>
                        <b-col md="10">
                          <b-button type="submit" variant="primary">
                            <i class="bx bxs-save mr-2"></i
                            >{{
                              $t(
                                "menuitems.administration.list.account.list.changePassword"
                              )
                            }}</b-button
                          >
                        </b-col>
                      </b-row>
                    </b-form>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import adminMixin from "@/mixins/administration";

export default {
  page: {
    title: "Account Settings",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [adminMixin],
  data() {
    return {
      profile: {
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
      },
      changePassword: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: "",
      },
    };
  },
  components: {
    Layout,
    PageHeader,
  },

  mounted() {
    const user = { ...this.$store.getters["auth/user"].user };
    this.profile.id = user.id;
    this.profile.firstName = user.first_name;
    this.profile.lastName = user.last_name;
    this.profile.mobile = user.mobile;
    this.profile.email = user.email;
  },

  methods: {
    async saveProfile() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.UpdateUser(this.profile);
        this.$store.dispatch("auth/setUser", {
          first_name: this.profile.firstName,
          last_name: this.profile.lastName,
          mobile: this.profile.mobile,
          email: this.profile.email,
        });
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Profile Saved", "Profile saved successfully", "success");
      } catch (e) {
        Swal.fire("Failed!", "Failed to save profile details", "error");
      }
    },

    showPassword() {
      var x = document.getElementById("formCheckRight2");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },

    async savePassword() {
      try {
        if (
          this.changePassword.newPassword !== this.changePassword.repeatPassword
        ) {
          Swal.fire(
            "Password Mismatch",
            "New password & repeat password does not match",
            "error"
          );
          return;
        }

        this.$store.dispatch("layout/changeLoaderValue", true);
        await this.ChangePassword({
          id: this.profile.id,
          oldPassword: this.changePassword.oldPassword,
          newPassword: this.changePassword.newPassword,
        });

        this.changePassword = {};
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Password Changed",
          "Password changed successfully",
          "success"
        );
      } catch (e) {
        Swal.fire("Failed!", e.response.data.message, "error");
      }
    },
  },
};
</script>